export const routePlannerTranslations = {
  en: {
    routeReasonRainStreak: "Fewer rainy days in a row",
    routeReasonGust: "Calmer gusts",
    routeReasonWind: "Lower wind exposure",
    routeReasonRain: "Less rain expected",
    routeReasonTemp: "Warmer daytime temperatures",
    routeReasonShelter: "More wind shelter",
    routeReasonTmax: "Warmer days",

    routeVerdictStayTitle: "Stay put",
    routeVerdictStayBody: "Conditions nearby do not look meaningfully better.",

    routeVerdictConsiderTitle: "Consider moving",
    routeVerdictConsiderBody: "There may be a slightly better option nearby.",

    routeVerdictMoveTitle: "Move camp",
    routeVerdictMoveBody: "There appears to be a clearly better option nearby.",

    routePlannerTitle: "Route Planner",
    routePlannerSelectBase:
      "Select a campsite (or use your location) to see if better weather may be nearby.",
    routePlannerBaseLabel: "Base",
    routePlannerRadius: "Travel radius",
    routePlannerWindowDays: "Window (days)",
    routePlannerShowAdvanced: "Advanced settings",
    routePlannerHideAdvanced: "Hide advanced settings",
    routePlannerWetThreshold: "Wet day threshold",
    previewPill: "Preview",
    routePlannerBestTomorrow: "Best nearby option tomorrow",
    routePlannerPreviewBody:
      "Chase the Weather compares nearby conditions and highlights where weather may be better tomorrow. \n\nWith Pro you can search a larger area, explore more days and see detailed comparisons.",
    routePlannerPreviewNoBetter:
      "No clearly better option was found within 30 km tomorrow. Pro searches a larger area and more days.",
    // #396 Revision 2: was "A better option was found nearby" — unqualified
    // "better option" with no weather qualifier, missed in the v1 audit.
    travelAdvisorMoveCtaBody:
      "Better weather was found nearby. Pro shows you exactly where and why.",
    travelAdvisorMoveCta: "See the better spot with Pro",
    // #396 Revision 2: was "There may be a slightly better option nearby" —
    // same unqualified pattern, and never stated the difference is
    // insufficient to recommend moving.
    travelAdvisorConsiderCtaBody:
      "Weather conditions may be slightly better nearby, but not enough to recommend moving. Pro helps you compare.",
    travelAdvisorConsiderCta: "Explore more options with Pro",
    routePlannerCandidatesPreselected: "Nearby campsites checked",
    routePlannerCandidatesScored: "Scored",
    routePlannerTopAlternatives: "Nearby alternatives",
    routePlannerNoAlternatives: "No clearly better nearby options found.",
    routePlannerNoReasons: "No clear reasons available yet.",

    routePlannerLockedBody:
      "Unlock Route Planner to see when nearby campsites may offer better weather.",

    routePlannerBaseForecastMissing: "Missing forecast for the selected base campsite.",
    routePlannerAlternativesCount: "Alternatives evaluated",
    routePlannerMinimalDifference: "Weather conditions are very similar.",

    routePlannerTrendMove: "Conditions look clearly better over the next {days} days.",
    routePlannerTrendMoveWithReasons:
      "Conditions look clearly better over the next {days} days — mainly because of: {reasons}.",

    routePlannerTrendConsider:
      "It may be worth moving over the next {days} days, but the weather difference is small.",
    routePlannerTrendConsiderWithReasons:
      "It may be worth moving over the next {days} days — mainly because of: {reasons}.",

    routePlannerTrendStay: "No nearby location looks noticeably better over the next {days} days.",

    routeDetailsComparedTo: "Compared to",
    routeDetailsDelta: "Difference",
    routeDetailsWhy: "Why this looks better",
    routeDetailsNoReasons: "No explanation data available.",
    routeDetailsDayByDay: "Day by day",
    routeDetailsNoDays: "No day breakdown available.",
    routeDetailsDate: "Date",
    routeDetailsBasePts: "Base pts",
    routeDetailsCandPts: "Option pts",
    routeDetailsWindPen: "Wind penalty",
    routeDetailsGustPen: "Gust penalty",
    routeDetailsRainPen: "Rain penalty",
    routeDetailsStreakPen: "Rain streak penalty",
    routeDetailsShelter: "Shelter",
    routeDetailsOpenHint: "Open details",
    routeBase: "Base",

    routeReason_wind: "Lower wind exposure",
    routeReason_gust: "Calmer gusts",
    routeReason_rain: "Less rain expected",
    routeReason_rainStreak: "Fewer rainy days in a row",
    routeReason_shelter: "More shelter",
    routeReason_temp: "Warmer daytime temperatures",
    routeReason_tmax: "Warmer daytime temperatures",
    routeReason_score: "Higher overall weather score",

    routeImproveNone: "Minimal difference",
    routeImproveSlight: "Slightly better",
    routeImproveBetter: "Better",
    routeImproveMuchBetter: "Much better",

    routeDayBetter: "Better",
    routeDaySame: "Similar",
    routeDayWorse: "Worse",

    routeDetailsShowAdvanced: "Show scoring details",
    routeDetailsHideAdvanced: "Hide scoring details",

    routeDayBetterSingular: "better day",
    routeDayBetterPlural: "better days",

    routeDaySameSingular: "similar day",
    routeDaySamePlural: "similar days",

    routeDayWorseSingular: "worse day",
    routeDayWorsePlural: "worse days",

    routeOverallResult: "Overall result for the selected days",
    routeOverallNote: "Some individual days may still be worse or similar.",
    routeDetailsPositiveDrivers: "Main reasons",

    routeOverallNextNDays: "next",
    routeOverallDays: "days",
    routeOverallTotalDelta: "Overall difference",
    routeOverallSeeBreakdown: "see breakdown",

    routeDecisionCounts: "{better} better days, {same} similar, {worse} worse.",
    routePlannerTopAlternativesNoBetter:
      "Nearby options (none clearly better over the next {days} days)",

    routeDaysBetter: "better days",
    routeDaysSame: "similar",
    routeDaysWorse: "worse",

    routeDetailsTempBase: "Temperature base",

    routeAdaptiveRadiusUsed: "Searched out to {used} km (max {max} km)",
    routeAdaptiveFoundBeyond:
      "No better option within {prev} km — but found a better one within {used} km.",
    routeAdaptiveNoBetterWithin: "No better option found within {used} km (max {max} km).",
    routeAdaptiveUsedShort: "Searched up to",

    routeWarningHigh: "Challenging weather conditions",
    routeWarning: "Weather caution",
    routeDetailsWarnings: "Caution",

    // #436 — visible source note, exact issue copy. The "vedur.is" token
    // inside the body is split out and wrapped in a native anchor by
    // HazardSourceNote.jsx; do not change this sentence except together
    // with that component's split logic.
    hazardSourceNoteHeading: "About this weather assessment:",
    hazardSourceNoteBody:
      "Caution indicators are calculated by Eltum Veðrið and are not official weather warnings. Check official warnings at vedur.is.",
    hazardSourceNoteNewTab: "Opens in a new tab",

    routeCompareDay: "Day",
    routeCompareBase: "Current",
    routeCompareCandidate: "Option",
    routeCompareDiff: "Difference",
    routeCompareWhy: "Why",
    routeCompareNoWarnings: "No caution indicators in this assessment",
    routeCompareReasonLessSevere: "Less severe weather",
    routeCompareReasonClearer: "Fewer caution indicators",
    routeCompareReasonStillBad: "Still rough",
    routeCompareReasonSimilar: "Similar caution indicators",
    routeCompareReasonWorse: "More caution indicators",
    routeCompareReasonGeneral: "Better conditions",

    routeWarnTypeWind: "Wind",
    routeWarnTypeGust: "Gusts",
    routeWarnTypeRain: "Rain",
    routeWarnTypeTempLow: "Cold",
    routeWarnTypeTempHigh: "Heat",

    routeCompareReasonHighHazard: "Challenging weather conditions",
    routeCompareReasonWarnHazard: "Weather caution",
    routeCompareReasonNoHazards: "No caution indicators in this assessment",

    routeCompareDiffNA: "—",
    routeCompareBaseNoDataTip: "Warnings for the current campsite are not available yet.",

    routeAggregateSlight: "Slightly better weather",

    routeDetailsRequiredDelta: "Required improvement for this distance",
    routeDetailsHazardImproved: "Lower weather risk here than at your current campsite",
    routeImproveSlightWorse: "Slightly worse",
    routeDetailsRawHint:
      "Scores shown as 0.0 can still hide a real difference when both values appear as 0 or 10.",
    routeCompareReasonBetterDespiteWarning: "Better conditions despite a caution indicator",

    routeHazardBlockerStay: "A high-risk weather day blocks a move recommendation.",
    routeHazardBlockerConsider: "A rough-weather day weakens this recommendation.",
    routeHazardBlockerShort: "Weather risk lowered this result.",

    routeRoughWeatherWindowSingle: "⚠ Rough weather may affect {date}.",
    routeRoughWeatherWindowRange: "⚠ Rough weather window: {start} → {end} ({days} days).",

    routeStayReasonHazard: "Weather risk elsewhere makes moving less advisable.",
    routeStayReasonSmallDifference: "The difference is too small to make moving worthwhile.",
    routeStayReasonAlreadyBest: "You are likely already in one of the better nearby spots.",
    routeStayGoodSpot: "Your current campsite compares well with nearby options.",

    impactWind: "Strong wind makes camping uncomfortable and tent pitching harder.",
    impactGust: "Gusts stress tent poles and pegs — especially overnight.",
    impactRain: "Rain keeps you in the tent and dampens gear.",
    impactRainStreak: "Consecutive rainy days make outdoor activities difficult.",
    impactColdWind: "Cold with wind makes sleeping and outdoor time more tiring.",
    impactWintry: "Snow or freezing rain adds risk and makes camp tasks harder.",
    impactShelter: "Natural shelter reduces felt wind and improves overall comfort.",

    routeEscapeStormTitle: "🚐 Escape the storm",
    routeEscapeStormBody: "Better conditions may be available nearby.",
    routeEscapeStormDestination: "{km} km → {site}",
    routeEscapeStormBaseWindow: "Hazardous weather may affect {place}.",
    routeEscapeStormCalmerNearby: "Calmer conditions may be available nearby.",

    routeRiskLabel: "Route risk",
    routeRiskLow: "Low",
    routeRiskMed: "Moderate",
    routeRiskHigh: "High",
    routeRiskUnknown: "Unknown",

    // Ticket #460 — shown instead of any Low/High/Moderate wording when
    // route-weather data is missing or invalid; must never say "low", "safe"
    // or "fine", and must not name an official body (#436).
    routeRiskUnknownDetail:
      "Route-weather data was insufficient to evaluate driving conditions on this route.",
    routeRiskPartialQualifier: "based on partial route data",

    routeRiskTomorrow: "Weather on the route tomorrow",

    routeRiskMaxWind: "Maximum wind",
    routeRiskMaxGust: "Maximum gust",
    routeRiskBasedOn: "Based on forecast wind and gust conditions along the route.",

    routeRiskAffectsDecision: "Driving conditions may affect this recommendation.",

    routeRiskHighTooltip: "Difficult driving conditions may occur along the route.",
    routeRiskMedTooltip: "Wind may affect driving conditions along the route.",

    routeDisclaimerTitle: "Route Planner disclaimer",

    routeDisclaimerBody1:
      "Route Planner uses weather forecasts to estimate conditions along travel routes and at nearby campsites.",

    routeDisclaimerBody2:
      "Weather in Iceland can change rapidly and actual conditions may differ from what is shown in the app.",

    routeDisclaimerBody3:
      "Chase the Weather provides informational guidance only. Users remain responsible for their own travel decisions.",

    routeDisclaimerConfirm: "I understand",

    routeHazardWindowPassingStorm: "A short passing storm is expected.",
    routeHazardWindowRoughWeather: "Rough weather may persist for several hours.",
    routeHazardWindowStormyPeriod: "A longer stormy period is expected in this window.",

    routeNarrativeBetterNearby: "Better conditions may be nearby: {destination}.",
    routeNarrativeRouteRiskHigh: "Road conditions on the way may currently be difficult.",
    routeNarrativeRouteRiskMed: "Road conditions on the way may be somewhat difficult.",

    routePlannerValue: "Find better weather nearby before you move.",

    decisionConsiderTitle: "Consider moving",
    decisionConsiderBody: "Better weather is likely at {site}.",
    // #396: "conditions" -> "weather conditions" (explicit qualifier, never
    // vague "better option"), and explicitly states the difference is NOT
    // enough for the product to recommend moving — consider must never read
    // as an immediate relocation recommendation.
    decisionConsiderBodyWindowAware:
      "Weather conditions may be slightly better at {site} over the next few days, but not enough for us to recommend moving — worth comparing.",

    decisionSimilarTitle: "No clear reason to move",
    decisionSimilarBody:
      "Weather conditions at nearby campsites look similar over the next few days. Staying where you are is likely the better choice.",
    decisionCurrentBetterTitle: "Stay where you are",
    decisionCurrentBetterBody:
      "Conditions at your current campsite look better than at the nearby alternatives over the next few days.",

    // #396: move must read as the strongest, forecast-grounded action
    // signal — an explicit recommendation, not a neutral invitation.
    decisionMoveBodyWindowAware:
      "Better weather is likely at {site} over the next few days — moving there is recommended, even though your current campsite scores best overall this week.",
    decisionMoveLockedBody:
      "Better weather is likely nearby — moving is recommended over the next few days.",
    // #396: explicitly hedged — weather may be a little better, but that is
    // NOT enough to recommend moving. Never "better option"/"slightly
    // better option" without a weather qualifier.
    decisionConsiderLockedBody:
      "Weather may be a little better nearby, but not enough to recommend moving — worth comparing or keeping an eye on it.",
    // move: canonical tone supports asserting a better spot exists.
    decisionLockedCta: "See why moving is recommended (Pro)",
    // consider: must stay hedged — compare/monitor wording, never a claim
    // that relocation is recommended.
    decisionConsiderLockedCta: "Compare conditions with Pro",

    // #396: candidate-visible secondary CTA — tone-only, identical across
    // every candidate-visible tier (see HomeDecisionCard.jsx's candidate CTA
    // precedence). Never repurposed from generic icCtaView/icCtaCompare.
    decisionMoveCandidateCta: "See why moving is recommended",
    decisionConsiderCandidateCta: "Compare conditions",

    // #396: non-color text cue distinguishing recommendation strength.
    decisionMoveStrengthBadge: "Recommended",
    decisionConsiderStrengthBadge: "Worth a look",

    decisionStayTitle: "Stay put for now",
    decisionStayBodyGood: "Conditions aren’t great, but no nearby option clearly looks better.",
    decisionStayBodyRough: "Weather won’t be perfect, but no nearby option clearly looks better.",

    travelAdvisorTitle: "Better weather nearby",
    travelAdvisorSubtitle: "Check whether conditions at a nearby campsite may be better",
    travelAdvisorShowDetails: "See details",
    travelAdvisorHideDetails: "Hide details",
    // Collapsed-teaser-only copy — deliberately neutral (no weather/verdict
    // claim) so it never competes with HomeDecisionCard's canonical tone.
    // Used ONLY in RoutePlannerCard's collapsed (resultsExpanded=false)
    // branch; every other travelAdvisorTitle/Subtitle usage is unchanged.
    travelAdvisorTeaserTitle: "Explore nearby conditions",
    travelAdvisorTeaserSubtitle: "See more details about nearby campsites.",

    routeStateMove: "Move",
    routeStateStay: "Stay",
    routeStateConsider: "Consider moving",
    routeStateBetterNearby: "Better weather nearby",
    routeStateFewerWarningsNearby: "Fewer caution indicators nearby",

    routeStateMoveDescription: "A nearby campsite looks better for the selected days.",
    routeStateStayDescription: "This campsite is still one of the better options nearby.",
    // #396: was "There may be a better option nearby..." — vague "better
    // option" with no weather qualifier, and didn't state the difference is
    // insufficient to recommend moving. This is RoutePlannerCard's own
    // expanded-details consider description, an actively rendered secondary
    // recommendation surface — must not contradict HomeDecisionCard's
    // canonical framing.
    routeStateConsiderDescription:
      "Weather may be a little better nearby, but not enough to recommend moving.",
    routeStateBetterNearbyDescription: "Nearby conditions look calmer or drier for part of your stay.",
    routeStateFewerWarningsNearbyDescription: "Nearby campsites show fewer own rough-weather caution indicators.",

    routePainMoveHeadline: "Why this matters",
    routePainMoveBody: "Moving could help you avoid the worst of the weather.",
    routePainMoveBulletAvoidWorst: "Moving could help you avoid the worst of the weather.",
    routePainMoveBulletStuckInside: "Less chance of being stuck inside because of the weather.",
    routePainMoveBulletTentCaravan: "Worth considering if you are in a tent, caravan, or campervan.",

    routePainConsiderHeadline: "Why this matters",
    // #396 Revision 3 (owner copy follow-up): removed the danger/hazard
    // contrast — genuinely dangerous conditions are rare and this state
    // normally describes modest comfort differences, not a "not dangerous"
    // reassurance.
    routePainConsiderBody: "Poor weather can still make camping less comfortable.",
    routePainConsiderBulletCheckNearby: "It may be worth checking nearby options before deciding to stay.",
    // #396 Revision 3: removed the "serious warnings" contrast — describes
    // ordinary camping comfort instead.
    routePainConsiderBulletLessPleasant: "Conditions may be a little less comfortable than ideal.",

    routePainStayHeadline: "Why this matters",
    routePainStayBody: "You do not appear to be missing much better conditions nearby.",
    routePainStayBulletNotEnoughGain: "There does not seem to be enough improvement nearby to justify moving.",
    routePainStayBulletNotMissingMuch: "You do not appear to be missing much better conditions in this area.",

    freeRecommendationBadge: "1 free recommendation per day",
    freeRecommendationAvailable: "You have one free recommendation today.",
    freeRecommendationUsed: "You have used your free recommendation for today.",
    freeRecommendationUpgrade: "Upgrade to Pro for unlimited daily recommendations.",
    freeRecommendationCta: "Upgrade to Pro",
    freeRecommendationProCta: "Get unlimited access",
  },
  is: {
    routeReasonRainStreak: "Færri rigningardagar í röð",
    routeReasonGust: "Rólegri hviður",
    routeReasonWind: "Minni vindálag",
    routeReasonRain: "Minna rigning á leiðinni",
    routeReasonTemp: "Hlýrra yfir daginn",
    routeReasonShelter: "Meira vindskjól",
    routeReasonTmax: "Hlýrri dagar",

    routeVerdictStayTitle: "Best að vera kyrr í bili",
    routeVerdictStayBody:
      "Aðstæður í nágrenninu virðast ekki nógu mikið betri til að það borgi sig að færa sig.",

    routeVerdictConsiderTitle: "Íhugaðu að færa þig",
    routeVerdictConsiderBody: "Það gæti verið aðeins betri kostur í nágrenninu.",

    routeVerdictMoveTitle: "Færðu þig",
    routeVerdictMoveBody: "Það virðist vera greinilega betri kostur í nágrenninu.",

    routePlannerTitle: "Ferðaráðgjafi",
    routePlannerSelectBase:
      "Veldu tjaldsvæði (eða notaðu staðsetningu) til að sjá hvort betra veður gæti verið í nágrenninu.",
    routePlannerBaseLabel: "Grunnstaður",
    routePlannerRadius: "Ferðafjarlægð",
    routePlannerWindowDays: "Gluggi (dagar)",
    routePlannerShowAdvanced: "Ítarlegar stillingar",
    routePlannerHideAdvanced: "Fela ítarlegar stillingar",
    routePlannerWetThreshold: "Votur dagur (viðmið)",
    previewPill: "Forsýn",
    routePlannerBestTomorrow: "Besti kostur í nágrenninu á morgun",
    routePlannerPreviewBody:
      "Eltum Veðrið ber saman aðstæður í nágrenninu og bendir á hvar veðrið gæti verið betra.\n\nMeð Pro geturðu skoðað stærra svæði, fleiri daga og séð nánari samanburð.",
    routePlannerPreviewNoBetter:
      "Enginn greinilega betri kostur fannst innan 30 km á morgun. Pro leitar á stærra svæði og yfir fleiri daga.",
    travelAdvisorMoveCtaBody:
      "Betra veður fannst í nágrenninu. Pro sýnir þér nákvæmlega hvar og hvers vegna.",
    travelAdvisorMoveCta: "Sjá betri staðinn með Pro",
    travelAdvisorConsiderCtaBody:
      "Veðurskilyrði gætu verið örlítið betri í nágrenninu, en ekki nóg til að mæla með að færa sig. Pro hjálpar þér að bera saman.",
    travelAdvisorConsiderCta: "Skoða fleiri möguleika með Pro",
    routePlannerCandidatesPreselected: "Skoðuð svæði í kringum þig",
    routePlannerCandidatesScored: "Metið",
    routePlannerTopAlternatives: "Valkostir í nágrenninu",
    routePlannerNoAlternatives: "Engir greinilega betri valkostir fundust í nágrenninu.",
    routePlannerNoReasons: "Engar skýrar ástæður tiltækar ennþá.",

    routePlannerLockedBody:
      "Opnaðu Ferðaráðgjafa til að sjá hvenær betra veður gæti verið á nærliggjandi tjaldsvæðum.",

    routePlannerBaseForecastMissing: "Vantar veðurspá fyrir valið tjaldsvæði.",
    routePlannerAlternativesCount: "Metin svæði",
    routePlannerMinimalDifference: "Veðuraðstæður eru mjög svipaðar.",

    routePlannerTrendMove: "Aðstæður líta greinilega betur út næstu {days} daga.",
    routePlannerTrendMoveWithReasons:
      "Aðstæður líta greinilega betur út næstu {days} daga — helst vegna: {reasons}.",

    routePlannerTrendConsider:
      "Það gæti borgað sig að færa sig næstu {days} daga, en veðurmunurinn er ekki mikill.",
    routePlannerTrendConsiderWithReasons:
      "Það gæti borgað sig að færa sig næstu {days} daga — helst vegna: {reasons}.",

    routePlannerTrendStay:
      "Það lítur ekki út fyrir að neinn staður í nágrenninu verði greinilega betri næstu {days} daga.",
    routeDetailsComparedTo: "Borið saman við",
    routeDetailsDelta: "Mismunur",
    routeDetailsWhy: "Af hverju þetta lítur betur út",
    routeDetailsNoReasons: "Engin skýringargögn tiltæk.",
    routeDetailsDayByDay: "Dag-fyrir-dag",
    routeDetailsNoDays: "Engin dagleg sundurliðun tiltæk.",
    routeDetailsDate: "Dagsetning",
    routeDetailsBasePts: "Grunnstig",
    routeDetailsCandPts: "Stig valkosts",
    routeDetailsWindPen: "Vindrefsing",
    routeDetailsGustPen: "Hviðurefsing",
    routeDetailsRainPen: "Rigningarrefsing",
    routeDetailsStreakPen: "Rigning í röð refsing",
    routeDetailsShelter: "Skjól",
    routeDetailsOpenHint: "Sjá nánar",
    routeBase: "Grunnstaður",

    routeReason_wind: "Minni vindálag",
    routeReason_gust: "Rólegri hviður",
    routeReason_rain: "Minna rigning á leiðinni",
    routeReason_rainStreak: "Færri rigningardagar í röð",
    routeReason_shelter: "Meira skjól",
    routeReason_temp: "Hlýrra yfir daginn",
    routeReason_tmax: "Hlýrra yfir daginn",
    routeReason_score: "Hærra heildarveðurskor",

    routeImproveNone: "Lítill munur",
    routeImproveSlight: "Örlítið betra",
    routeImproveBetter: "Betra",
    routeImproveMuchBetter: "Miklu betra",

    routeDayBetter: "Betra",
    routeDaySame: "Svipað",
    routeDayWorse: "Lakara",

    routeDetailsShowAdvanced: "Sýna stig og sundurliðun",
    routeDetailsHideAdvanced: "Fela stig og sundurliðun",

    routeDayBetterSingular: "dagur betri",
    routeDayBetterPlural: "dagar betri",

    routeDaySameSingular: "dagur svipaður",
    routeDaySamePlural: "dagar svipaðir",

    routeDayWorseSingular: "dagur verri",
    routeDayWorsePlural: "dagar verri",

    routeOverallResult: "Heildarniðurstaða næstu daga",
    routeOverallNote: "Sumir dagar geta samt verið lakari eða svipaðir.",
    routeDetailsPositiveDrivers: "Helstu ástæður",

    routeOverallNextNDays: "næstu",
    routeOverallDays: "daga",
    routeOverallTotalDelta: "Heildarmismunur",
    routeOverallSeeBreakdown: "sjá sundurliðun",

    routeDecisionCounts: "{better} dagar betri, {same} svipaðir, {worse} verri.",
    routePlannerTopAlternativesNoBetter:
      "Nálægir valkostir (engir greinilega betri næstu {days} daga)",

    routeDaysBetter: "dagar betri",
    routeDaysSame: "svipaðir",
    routeDaysWorse: "verri",

    routeDetailsTempBase: "Hita-grunnur",

    routeAdaptiveRadiusUsed: "Leitaði út í {used} km (max {max} km)",
    routeAdaptiveFoundBeyond:
      "Enginn betri kostur fannst innan {prev} km — en betri kostur fannst innan {used} km.",
    routeAdaptiveNoBetterWithin: "Enginn betri kostur fannst innan {used} km (max {max} km).",
    routeAdaptiveUsedShort: "Leitað út í",

    routeWarningHigh: "Erfiðar veðuraðstæður",
    routeWarning: "Varúð vegna veðurs",

    routeDetailsWarnings: "Varúð",

    // #436 — visible source note, exact issue copy. See EN block comment.
    hazardSourceNoteHeading: "Um veðurmatið:",
    hazardSourceNoteBody:
      "Varúðarmerkingar eru reiknað mat Eltum Veðrið, ekki opinberar veðurviðvaranir. Skoðaðu opinberar viðvaranir á vedur.is.",
    hazardSourceNoteNewTab: "Opnast í nýjum flipa",

    routeCompareDay: "Dagur",
    routeCompareBase: "Núverandi",
    routeCompareCandidate: "Valkostur",
    routeCompareDiff: "Munur",
    routeCompareWhy: "Af hverju",
    routeCompareNoWarnings: "Engar varúðarmerkingar í þessu mati",
    routeCompareReasonLessSevere: "Minni hætta",
    routeCompareReasonClearer: "Færri varúðarmerkingar",
    routeCompareReasonStillBad: "Enn slæmt veður",
    routeCompareReasonSimilar: "Svipaðar varúðarmerkingar",
    routeCompareReasonWorse: "Fleiri varúðarmerkingar",
    routeCompareReasonGeneral: "Betri aðstæður",

    routeWarnTypeWind: "Vindur",
    routeWarnTypeGust: "Hviður",
    routeWarnTypeRain: "Rigning",
    routeWarnTypeTempLow: "Kuldi",
    routeWarnTypeTempHigh: "Hiti",

    routeCompareReasonHighHazard: "Erfiðar veðuraðstæður",
    routeCompareReasonWarnHazard: "Varúð vegna veðurs",
    routeCompareReasonNoHazards: "Engar varúðarmerkingar í þessu mati",
    routeCompareDiffNA: "—",
    routeCompareBaseNoDataTip: "Viðvaranir fyrir núverandi tjaldsvæði eru ekki tiltækar ennþá.",
    routeAggregateSlight: "Örlítið betra veður",

    routeDetailsRequiredDelta: "Lágmarksbæting miðað við fjarlægð",
    routeDetailsHazardImproved: "Minni veðuráhætta hér en á núverandi stað",
    routeImproveSlightWorse: "Örlítið lakara",
    routeDetailsRawHint:
      "0.0 stig geta samt falið raunverulegan mun þegar bæði gildi birtast sem 0 eða 10.",
    routeCompareReasonBetterDespiteWarning: "Betri aðstæður þrátt fyrir varúðarmerkingu",

    routeHazardBlockerStay: "Dagur með slæmu veðri kemur í veg fyrir flutningsráðleggingu.",
    routeHazardBlockerConsider: "Dagur með slæmu veðri veikir þessa ráðleggingu.",
    routeHazardBlockerShort: "Veðuráhætta dró úr niðurstöðunni.",

    routeRoughWeatherWindowSingle: "⚠ Slæmt veður gæti haft áhrif {date}.",
    routeRoughWeatherWindowRange:
      "⚠ Slæmt veður gæti verið framundan: {start} → {end} ({days} dagar).",

    routeStayReasonHazard: "Veðuráhætta annars staðar gerir flutning síður ráðlegan.",
    routeStayReasonSmallDifference: "Munurinn er of lítill til að það borgi sig að færa sig.",
    routeStayReasonAlreadyBest: "Þú ert líklega nú þegar á einum af betri stöðunum í nágrenninu.",
    routeStayGoodSpot: "Núverandi tjaldsvæðið þitt ber sig vel saman við nálægar leiðir.",

    impactWind: "Sterkur vindur gerir tjaldlíf erfitt og erfiðara að tjalda.",
    impactGust: "Hviður setja tjaldstör og pinnar í þraut — sérstaklega á nóttunni.",
    impactRain: "Rigning heldur þér inni og bleytir búnað.",
    impactRainStreak: "Margir rigningardagar í röð gera útiveru erfið.",
    impactColdWind: "Kuldi með vindi gerir svefn og útiveru þreytandi.",
    impactWintry: "Snjór eða frárigning bætir við áhættu og gerir tjaldlíf erfiðara.",
    impactShelter: "Náttúrulegt skjól dregur úr fundnum vindi og eykur þægindi.",

    routeEscapeStormTitle: "🚐 Forðastu óveðrið",
    routeEscapeStormBody: "Betri aðstæður gætu verið í nágrenninu.",
    routeEscapeStormDestination: "{km} km → {site}",
    routeEscapeStormBaseWindow: "Slæmt veður gæti haft áhrif á {place}.",
    routeEscapeStormCalmerNearby: "Rólegra veður gæti verið í nágrenninu.",

    routeRiskLabel: "Áhætta á leið",
    routeRiskLow: "Lág",
    routeRiskMed: "Miðlungs",
    routeRiskHigh: "Há",
    routeRiskUnknown: "Óþekkt",

    routeRiskUnknownDetail:
      "Veðurgögn á leiðinni voru ófullnægjandi til að meta akstursaðstæður.",
    routeRiskPartialQualifier: "byggt á ófullkomnum gögnum af leiðinni",

    routeRiskTomorrow: "Veður á leiðinni á morgun",

    routeRiskMaxWind: "Hámarksvindur",
    routeRiskMaxGust: "Hámarkshviða",

    routeRiskBasedOn: "Byggt á spáðri vind- og hviðustyrk á leiðinni.",

    routeRiskAffectsDecision: "Akstursaðstæður geta haft áhrif á þessa ráðleggingu.",

    routeRiskHighTooltip: "Erfiðar akstursaðstæður geta komið upp á leiðinni.",
    routeRiskMedTooltip: "Vindur gæti haft áhrif á akstur á leiðinni.",

    routeDisclaimerTitle: "Fyrirvari fyrir Ferðaráðgjafa",

    routeDisclaimerBody1:
      "Ferðaráðgjafinn notar veðurspár til að meta aðstæður á ferðaleiðum og nálægum tjaldsvæðum.",

    routeDisclaimerBody2:
      "Veður á Íslandi getur breyst hratt og raunverulegar aðstæður geta verið frábrugðnar því sem birtist í appinu.",

    routeDisclaimerBody3:
      "Eltum Veðrið veitir eingöngu upplýsingar til viðmiðunar. Notendur bera sjálfir ábyrgð á eigin ferðarákvörðunum.",

    routeDisclaimerConfirm: "Ég skil",

    routeHazardWindowPassingStorm: "Stuttur veðurskafli gæti gengið yfir.",
    routeHazardWindowRoughWeather: "Slæmt veður gæti staðið yfir í nokkrar klukkustundir.",
    routeHazardWindowStormyPeriod: "Lengra stormaskeið er líklegt á þessu tímabili.",

    routeNarrativeBetterNearby: "Betri aðstæður gætu verið í nágrenninu: {destination}.",
    routeNarrativeRouteRiskHigh: "Aðstæður á leiðinni gætu þó verið erfiðar núna.",
    routeNarrativeRouteRiskMed: "Aðstæður á leiðinni gætu verið aðeins erfiðar.",

    routePlannerValue: "Finndu betra veður í nágrenninu áður en þú færir þig.",

    decisionConsiderTitle: "Íhugaðu að færa þig",
    decisionConsiderBody: "Betra veður er líklegt hjá {site}.",
    decisionConsiderBodyWindowAware:
      "Veðurskilyrði gætu verið örlítið betri hjá {site} næstu daga, en ekki nóg til að mæla með að færa sig — vert að bera saman.",

    decisionSimilarTitle: "Engin skýr ástæða til að færa sig",
    decisionSimilarBody:
      "Veðrið á nálægum tjaldsvæðum virðist svipað næstu daga. Líklega er best að halda sig þar sem þú ert.",
    decisionCurrentBetterTitle: "Haltu þig þar sem þú ert",
    decisionCurrentBetterBody:
      "Aðstæður á núverandi tjaldsvæði virðast betri en á nálægum valkostum næstu daga.",

    decisionMoveBodyWindowAware:
      "Betra veður er líklegt hjá {site} næstu daga — mælt er með að færa sig þangað, jafnvel þótt núverandi tjaldsvæði skori hæst þessa vikuna.",
    decisionMoveLockedBody:
      "Betra veður er líklegt í nágrenninu — mælt er með að færa sig næstu daga.",
    decisionConsiderLockedBody:
      "Veðrið gæti verið aðeins betra í nágrenninu, en ekki nóg til að mæla með að færa sig — vert að bera saman eða fylgjast með.",
    // move: canonical tónn leyfir að fullyrða að betri staður sé til.
    decisionLockedCta: "Sjá af hverju mælt er með að færa sig (Pro)",
    // consider: verður að vera hedged — aldrei "fannst"/staðreynd um betri stað.
    decisionConsiderLockedCta: "Bera saman aðstæður með Pro",

    decisionMoveCandidateCta: "Sjá af hverju mælt er með að færa sig",
    decisionConsiderCandidateCta: "Bera saman aðstæður",

    decisionMoveStrengthBadge: "Mælt með",
    decisionConsiderStrengthBadge: "Þess virði að skoða",

    decisionStayTitle: "Best að vera kyrr í bili",
    decisionStayBodyGood:
      "Aðstæður eru ekki frábærar, en enginn nálægur staður lítur greinilega betur út.",
    decisionStayBodyRough:
      "Veðrið verður ekki fullkomið, en enginn nálægur valkostur virðist vera greinilega betri.",

    travelAdvisorTitle: "Betra veður í nágrenninu",
    travelAdvisorSubtitle: "Sjáðu hvort betra veður sé í nágrenninu.",
    travelAdvisorShowDetails: "Sjá nánar",
    travelAdvisorHideDetails: "Fela nánar",
    travelAdvisorTeaserTitle: "Skoða aðstæður í nágrenninu",
    travelAdvisorTeaserSubtitle: "Sjáðu fleiri upplýsingar um nálæga staði.",

    routeStateMove: "Færa sig",
    routeStateStay: "Vera áfram",
    routeStateConsider: "Íhuga að færa sig",
    routeStateBetterNearby: "Betra veður í nágrenninu",
    routeStateFewerWarningsNearby: "Færri varúðarmerkingar í nágrenninu",

    routeStateMoveDescription: "Nálægt tjaldsvæði lítur betur út fyrir valda daga.",
    routeStateStayDescription: "Þetta tjaldsvæði er enn einn betri kosturinn í nágrenninu.",
    routeStateConsiderDescription:
      "Veðrið gæti verið aðeins betra í nágrenninu, en ekki nóg til að mæla með að færa sig.",
    routeStateBetterNearbyDescription: "Veðrið í nágrenninu virðist rólegra eða þurrara hluta dvalarinnar.",
    routeStateFewerWarningsNearbyDescription: "Nálæg tjaldsvæði sýna færri eigin varúðarmerkingar vegna veðurs.",

    routePainMoveHeadline: "Af hverju skiptir þetta máli",
    routePainMoveBody: "Að færa sig gæti hjálpað þér að forðast versta veðrið.",
    routePainMoveBulletAvoidWorst: "Að færa sig gæti hjálpað þér að forðast versta veðrið.",
    routePainMoveBulletStuckInside: "Minni líkur á að sitja fastur inni í tjaldi eða bíl vegna veðurs.",
    routePainMoveBulletTentCaravan: "Þess virði að skoða sérstaklega ef þú ert í tjaldi, ferðavagni eða húsbíl.",

    routePainConsiderHeadline: "Af hverju skiptir þetta máli",
    routePainConsiderBody: "Slakt veður getur samt gert tjaldlífið minna notalegt.",
    routePainConsiderBulletCheckNearby: "Það gæti borgað sig að skoða aðra staði áður en þú ákveður að vera kyrr.",
    routePainConsiderBulletLessPleasant: "Aðstæður gætu verið aðeins minna notalegar en best verður á kosið.",

    routePainStayHeadline: "Af hverju skiptir þetta máli",
    routePainStayBody: "Þú virðist ekki vera að missa af miklu betri aðstæðum í nágrenninu.",
    routePainStayBulletNotEnoughGain: "Það virðist ekki vera nægur veðurmunur til að réttlæta ferðalagið.",
    routePainStayBulletNotMissingMuch: "Þú virðist ekki vera að missa af miklu betri aðstæðum á þessu svæði.",

    freeRecommendationBadge: "1 ókeypis ráðgjöf á dag",
    freeRecommendationAvailable: "Þú átt eina ókeypis ráðleggingu í dag.",
    freeRecommendationUsed: "Þú hefur notað þína ókeypis ráðleggingu í dag.",
    freeRecommendationUpgrade: "Uppfærðu í Pro fyrir ótakmarkaðar ráðleggingar á dag.",
    freeRecommendationCta: "Uppfærðu í Pro",
    freeRecommendationProCta: "Fáðu ótakmarkaðan aðgang",
  },
};
